<div
  class="full-page w-100 h-100"
  [style.background-image]="
    'url(' +
    ('login-registration/login-background.png' | contentAssetImage) +
    ')'
  "
>
  <div class="container d-flex justify-content-center login-section">
    <img
      [src]="'login-registration/phxid.jpg' | contentAssetImage"
      alt=""
      class="logo"
    />

    <div class="login-box bg-white">
      <h3 class="">{{ "login.page.title" | translate }}</h3>
      <div class="font-size-14">
        {{ "login.page.description" | translate }}
      </div>
      <div class="w-100 mt-4">
        <fgb-tm-user-login></fgb-tm-user-login>
      </div>
    </div>
  </div>
</div>
